import { useMemo } from 'react'
import { useQuery } from 'apollo-client'
import { constants } from 'helpers'
import { useFt } from 'hooks'
import { usePathname } from 'router'

import pageContentStrapiQuery from './graph/pageContent.strapi.graphql'

import modifyDynamicPageContent from './modifyDynamicPageContent'


export type UseDynamicPageContentProviderProps = {
  ssr?: boolean
}

const useDynamicPageContentProvider = (props: UseDynamicPageContentProviderProps = {}) => {
  const { ssr = true } = props

  const isStrapiDynamicPageEnabled = useFt(constants.features.strapiDynamicPage)

  const pathname = usePathname()

  const { data, isFetching } = useQuery(pageContentStrapiQuery, {
    client: 'strapi',
    ssr,
    skip: !isStrapiDynamicPageEnabled,
    variables: {
      filters: {
        url: {
          eq: pathname,
        },
      },
    },
    context: {
      ssrCache: true,
    },
  })

  const modifiedData = useMemo(() => {
    if (!data) {
      return null
    }

    return modifyDynamicPageContent(data?.pages?.data?.[0]?.attributes)
  }, [ data ])

  return {
    data: modifiedData,
    isFetching,
  }
}

export default useDynamicPageContentProvider
